import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { KpiScoreComponent } from '../../visuals/kpi-score/kpi-score.component';
import { StateService } from '../../services/state.service';
import { DateService } from '../../services/date.service';
import { InstitutionType } from '../../services/institution.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-peer-comparison-institution',
  standalone: true,
  imports: [CommonModule, RouterModule, KpiScoreComponent],
  templateUrl: './peer-comparison-institution.component.html',
  styleUrl: './peer-comparison-institution.component.scss'
})
export class PeerComparisonInstitutionComponent {
  reportDate = signal<Date | undefined>(undefined);
  showMore = signal<boolean>(false);

  private router = inject(Router);
  private stateService = inject(StateService);
  private dateService = inject(DateService);

  readonly institution = inject(StateService).institution;
  readonly institutionType = computed(() => this.institution()?.institutionType);
  readonly InstitutionType = InstitutionType;

  readonly hasPeerComparison = input.required<boolean>();
  readonly hasNonMaturity = input.required<boolean>();
  readonly hasBothProducts = input.required<boolean>();
  readonly hasNoProducts = input.required<boolean>();


  protected readonly productState = computed(() => ({
    hasPeerComparison: this.hasPeerComparison(),
    hasNonMaturity: this.hasNonMaturity(),
    hasBothProducts: this.hasBothProducts()
  }));

  constructor() {
    effect(() => {
      const institution = this.institution();
      if (institution && this.dateService.datesFetched()) {
        setTimeout(() => {
          this.reportDate.set(this.dateService.getCurrentDate(institution.institutionType));
        });
      }
    });
  }

  getMetricId(ffiec: string, ncua: string): string | undefined {
    if (this.institutionType() === InstitutionType.bank) {
      return ffiec;
    } else if (this.institutionType() === InstitutionType.creditUnion) {
      return ncua;
    } else {
      return undefined;
    }
  }

  navigate(path: string) {
    if (this.productState().hasPeerComparison) {
      this.router.navigate([path]);
    }
    else {
      Swal.fire({
        title: 'No Subscription',
        html: 'You currently do not have access to this product. If this is an error, please contact your system administrator or reach out to <a href="mailto:support@lakehouse-analytics.com">LakeHouse Support</a>',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#5f5f5f',
      });
    }
  }
}
